@charset "UTF-8";

/* src/app/forms/formview/form-field-properties/form-field-properties-detail-actions/form-field-properties-detail-actions.component.scss */
.grid-view {
  position: relative;
  height: 100%;
  min-height: 200px;
  min-height: 200px;
  overflow: auto;
}
.info-title {
  font-size: 80%;
  font-weight: 500;
  color: var(--tem-ink);
}
.info-desc {
  font-size: 80%;
  color: var(--tem-muted);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  text-align: center;
}
.props-grid-actions {
  display: grid;
  grid-template-columns: 3fr 5fr 1fr;
  align-items: center;
  gap: 4px;
  border-bottom: 1px solid var(--tem-border);
  padding: 4px;
}
.props-grid-header {
  background: var(--tem-surface-2);
  border-radius: var(--tem-radius) var(--tem-radius) 0 0;
}
.actions-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--tem-space-2) var(--tem-space-3);
  background: var(--tem-surface-2);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
}
.left-edit {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 30%;
  padding-left: 4px;
  padding-right: 4px;
}
.container-data {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-right: 4px;
  min-height: 200px;
}
.container-formula-tester {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 4px;
  padding-top: 4px;
  overflow: auto;
  min-height: 150px;
  height: 150px;
}
.right-edit {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 70%;
  padding-left: 4px;
  padding-right: 4px;
}
app-formula-tester {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.fields {
  width: 100%;
  display: flex;
  flex-direction: row;
  font-size: 10px;
  padding-left: 10px;
  height: 100%;
  justify-content: space-between;
  align-items: center;
}
search-input {
  height: 40px !important;
  width: 100%;
}
.edit-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: relative;
}
.form-edit-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 6px;
}
.span1 {
  margin-left: 10px;
}
.float-add-button {
  position: absolute;
  right: 40px;
  bottom: 30px;
  z-index: 10;
}
textarea {
  height: 100%;
  resize: none;
}
/*# sourceMappingURL=form-field-properties-detail-actions.component.css.map */
